export const DEVICE_NAME_REGEX = /^[A-Za-z0-9 ]+$/;
export const DEVICE_NAME_VALIDATION_MESSAGE = 'Only allows letters numbers and spaces (A-z, 0-9, )';
export const DeviceStatus: Record<string, string> = {
  ACTIVE: 'active',
  ONLINE: 'Online',
  OFFLINE: 'Offline',
  DISCONNECTED: 'disconnected',
  INACTIVE: 'inactive',
  QUARANTINED: 'quarantined',
  UNKNOWN: 'unknown',
};
export const DeviceTooltipStatus: Record<string, string> = {
  active: 'Connected',
  online: 'Online',
  offline: 'Offline',
  disconnected: 'Disconnected',
  inactive: 'Status Unknown',
  quarantined: 'Quarantined',
  unknown: 'Not on Network',
};
